import React from 'react';
import { PROGRESS_BAR_COLORS } from '../../constants';
import classes from './BallTypeTab.module.scss';

const BallTypeTab = ({ title, currentCount, minCount, maxCount, isActive, onClick }) => {
  const isExact = minCount === maxCount;
  const isValid =
    (isExact && currentCount === maxCount) ||
    (!isExact && currentCount >= minCount && currentCount <= maxCount);
  const progressColor = isValid ? PROGRESS_BAR_COLORS.VALID : PROGRESS_BAR_COLORS.INVALID;
  const progressPct = Math.min((currentCount / maxCount) * 100, 100);

  return (
    <button
      type="button"
      onClick={onClick}
      className={
        classes.Tab
        + (isActive ? ' ' + classes.Active : ' ' + classes.Inactive)
        + (isValid ? ' ' + classes.Valid : '')
      }
    >
      <span className={classes.Title}>{title}</span>
      <span className={classes.ProgressTrack}>
        <span
          className={classes.ProgressBar}
          style={{ width: `${progressPct}%`, backgroundColor: progressColor }}
        />
      </span>
      <span className={classes.Count} style={{ color: progressColor }}>
        {currentCount} / {maxCount}
      </span>
    </button>
  );
};

export default BallTypeTab;
